__turbopack_context__.v({
  "button": "m-column-item-module__D3eu2q__button",
  "container": "m-column-item-module__D3eu2q__container",
  "content": "m-column-item-module__D3eu2q__content",
});
